<div class="parametros-cemento-filtros">
  <div class="parametros-cemento-filtro-buscar">
    <app-cbb-field
      label="Buscar"
      placeholder="Nombre, valor, descripción..."
      [clearable]="true"
      [ngModel]="store.query().search"
      (ngModelChange)="onSearchTermChange($event)"
    ></app-cbb-field>
  </div>
</div>

<app-admin-server-table
  [columns]="tableColumns"
  [rows]="store.items()"
  [loading]="store.loading()"
  [emptyMessage]="'No hay parámetros para mostrar.'"
  [ordering]="store.query().ordering"
  [pagination]="paginationState"
  [summaryNoun]="'parámetros'"
  [rowTrackBy]="trackByItem"
  (orderingChange)="onOrderingChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-admin-server-table>

<ng-template #actionsCellTpl let-row>
  <div class="d-flex gap-1 justify-content-center align-items-center">
    <app-cbb-table-action-icon
      variant="edit"
      label="Editar"
      [disabled]="store.loading()"
      (action)="openEditModal(row)"
    ></app-cbb-table-action-icon>
  </div>
</ng-template>
